<template>
  <div class="flex flex-wrap justify-between items-center">
    <b-loading :active.sync="loading_inicial" />

    <Lynx-Title text="Alteração e Baixa de Empresa" />

    <Lynx-Button
      @click.native.prevent="openCreateModal()"
      class="mb-6 col-md-2"
      text="Solicitar Alteração"
      size="small"
    />
    <Lynx-Button
      @click.native.prevent="relatorio()"
      class="mb-6 col-md-2"
      text="Relatorio"
      size="small"
    />

    <Lynx-Button
      @click.native.prevent="fetchEmpresaAlteracoes()"
      class="mb-6 col-md-2"
      text="Atualizar"
      size="small"
    />
    <div class="w-full flex flex-between gap-3 gap-2">
      <label class="w-1/5">
          <Lynx-Label label="Seleciona um período" />
          <b-datepicker
            v-model="filtros.data"
            placeholder="Seleciona um período"
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-3, 3]"
            range
          >
            <b-button
              label="Clear"
              type="is-danger"
              icon-left="close"
              outlined
              @click="filtros.data = null"
            />
          </b-datepicker>
        </label>
      <label>
        <Lynx-Label label="Status" />
        <b-select placeholder="Selecione um status" v-model="filtros.status">
          <option
            v-for="(option, key) in statusOptions"
            :value="option.value"
            :key="key"
            v-text="option.label"
          />
        </b-select>
      </label>

      <label class="w-1/4">
        <Lynx-Label label="ID Empresas" class=" " />

        <Lynx-Input v-model="empresas_id" />
      </label>
    </div>
    <div class="flex justify-end mb-2">
      <label>
        <Lynx-Label label="Por paginas" class=" " />

        <b-select v-model="filtros.perPage">
          <option
            :value="perPageOption"
            v-for="perPageOption in perPageOptions"
            :key="perPageOption"
          >
            {{ perPageOption }}
          </option>
        </b-select>
      </label>
    </div>

    <b-table
      v-if="lista_empresa_alteracao"
      class="w-full table table-responsive rounded-t-none"
      :loading="loading"
      hoverable
      backend-pagination
      :columns="columns"
      :data="loading ? [] : lista_empresa_alteracao"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      @page-change="onPageChange"
      paginated
      striped
      style="font-size: 14px"
    >
      <template slot-scope="props">
        <b-table-column style="width: 100px" field="empresa_id">
          {{ (props.row.empresa && props.row.empresa.id) || "" }}
        </b-table-column>

        <b-table-column field="razao_social">
          {{
            props.row.empresa
              ? props.row.empresa.razao_social || props.row.empresa.nome_empresa
              : ""
          }}
        </b-table-column>

        <b-table-column field="status">
          {{ props.row.status_label }}
        </b-table-column>

        <b-table-column field="solicitacao.tipo">
          {{ props.row.solicitacao.tipo }}
        </b-table-column>
        <b-table-column field="created_at">
          {{ formatEnToBr(props.row.created_at) }}
        </b-table-column>

        <b-table-column field="updated_at">
          {{ formatEnToBr(props.row.data_finalizado) }}
        </b-table-column>

        <b-table-column
          class="flex justify-between"
          field="actions"
          label=""
          width="120"
        >
          <b-tooltip
            v-if="
              props.row.status_id == 1 ||
              props.row.status_id == 3 ||
              props.row.status_id == 6
            "
            label="Confirmar Pagamento"
            position="is-bottom"
            type="is-success"
          >
            <button
              class="flex items-center justify-center"
              @click.prevent="confirmPayment(props.row.id)"
            >
              <b-icon icon="currency-usd"></b-icon>
            </button>
          </b-tooltip>

          <b-tooltip
            v-if="
              props.row.status_id == 2 ||
              props.row.status_id == 4 ||
              props.row.status_id == 5
            "
            label="Editar"
            position="is-bottom"
          >
            <button
              class="flex items-center justify-center"
              @click.prevent="openEditModal(props.row)"
            >
              <b-icon icon="circle-edit-outline"></b-icon>
            </button>
          </b-tooltip>

          <b-tooltip label="Excluir" position="is-bottom" type="is-danger">
            <button
              class="flex items-center justify-center"
              @click.prevent="deleteEmpresaAlteracao(props.row.id)"
            >
              <b-icon icon="delete-forever"></b-icon>
            </button>
          </b-tooltip>
        </b-table-column>
      </template>

      <template slot="empty">
        <Not-Found-Data
          class="mt-8"
          text="Nenhuma solicitação de alteração foi encontrada"
        />
      </template>
    </b-table>

    <b-modal :active.sync="empresaAlteracaoCreateModalOpened">
      <EmpresaAlteracaoCreateModal @created="alteracaoCreated()" />
    </b-modal>

    <b-modal :active.sync="empresaAlteracaoEditModalOpened">
      <EmpresaAlteracaoEditModal
        :empresaAlteracao="selectedEmpresaAlteracao"
        @edited="alteracaoEdited()"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  EmpresaAlteracaoIndex,
  EmpresaAlteracaoDelete,
  EmpresaAlteracaoUpdate,
} from "@/services/requests/empresaAlteracao";
import NotFoundData from "@/components/layouts/NotFoundData";
import EmpresaAlteracaoCreateModal from "@/views/empresas/alteracao/CreateModal";
import EmpresaAlteracaoEditModal from "@/views/empresas/alteracao/EditModal";
import moment from "moment";
export default {
  name: "EmpresaAlteracaoIndex",
  components: {
    NotFoundData,
    EmpresaAlteracaoCreateModal,
    EmpresaAlteracaoEditModal,
  },
  data() {
    return {
      empresaAlteracaoCreateModalOpened: false,
      empresaAlteracaoEditModalOpened: false,
      selectedEmpresaAlteracao: null,
      empresaAlteracoes: [],
      loading: false,
      columns: [
        {
          field: "alteracao.empresa.id",
          label: "id",
        },
        {
          field: "alteracao.empresa.razao_social",
          label: "Razão Social",
        },
        {
          field: "status_label",
          label: "status",
        },

        {
          field: "solicitacao.tipo",
          label: "Tipo de solicitação",
        },
        {
          field: "created_at",
          label: "criado",
        },
        {
          field: "updated_at",
          label: "finalizado",
        },
      ],
      statusOptions: [
        {
          label: "todos",
          value: null,
        },
        {
          label: "Em processo de alteração de alvará",
          value: 2,
        },
        {
          label: "Em processo de baixa da empresa",
          value: 4,
        },
        {
          label: "Aguardando pagamento alteração alvara",
          value: 1,
        },
          {
          label: "Aguardando pagamento cnpj alteração",
          value: 6,
        },
        {
          label: "Em processo de alteração do CNPJ",
          value: 5,
        },
        {
          label: "Processo finalizado",
          value: 100,
        },
      ],
      status: "todos",
      filtros: {
        page: 1,
        perPage: 10,
        status: null,
        empresas_id: null,
        data: null,
      },

      perPageOptions: [10, 50, 100],
      current_page: 1,
      lista_setor: [],
      empresas_id: null,
      loading_inicial: null,
    };
  },
  created() {
    this.listar_inicial();
  },
  computed: {
    lista_empresa_alteracao() {
      return this.empresaAlteracoes.data;
    },
    pagination() {
      this.filtros.page = this.current_page;

      return this.empresaAlteracoes.pagination;
    },
  },
  watch: {
    "filtros.perPage"() {
      this.fetchEmpresaAlteracoes();
    },
    current_page() {
      this.fetchEmpresaAlteracoes();
    },
  },
  methods: {
    async listar_inicial() {
      this.loading_inicial = true;
      await this.fetchEmpresaAlteracoes();
      this.loading_inicial = false;
    },
    exibirStatuslabel(status) {
      const statusLabel = this.statusOptions.find(
        (option) => option.value == status
      );
      return statusLabel ? statusLabel.label : "sem status";
    },
    alteracaoCreated() {
      this.empresaAlteracaoCreateModalOpened = false;
      this.fetchEmpresaAlteracoes();
    },
    alteracaoEdited() {
      this.empresaAlteracaoEditModalOpened = false;
      this.fetchEmpresaAlteracoes();
    },
    openCreateModal() {
      this.empresaAlteracaoCreateModalOpened = true;
    },
    async fetchEmpresaAlteracoes() {
      this.loading = true;

      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }

      const { filtros } = this;
      await EmpresaAlteracaoIndex(filtros)
        .then((res) => {
          this.empresaAlteracoes = res.data;
        })
        .finally(() => (this.loading = false));
    },
    deleteEmpresaAlteracao(EmpresaAlteracaoId) {
      this.$buefy.dialog.confirm({
        title: "Excluindo Solicitação de Alteração",
        message:
          "Isso irá excluir essa solicitação de alteração, deseja realmente continuar?",
        confirmText: "Excluir",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.loading = true;
          EmpresaAlteracaoDelete(EmpresaAlteracaoId)
            .then(() => {
              this.$snack.success(
                "Solicitação de alteração excluída com sucesso!"
              );
            })
            .finally(() => {
              this.loading = false;
              this.fetchEmpresaAlteracoes();
            });
        },
      });
    },
    confirmPayment(EmpresaAlteracaoId) {
      this.$buefy.dialog.confirm({
        title: "Confirmação de Pagamento",
        message: "Confirma o pagamento da solicitação?",
        confirmText: "Confirmar",
        type: "is-success",
        hasIcon: true,
        onConfirm: () => {
          this.loading = true;
          EmpresaAlteracaoUpdate(EmpresaAlteracaoId, [])
            .then(() => {
              this.$snack.success("Pagamento confirmado com sucesso!");
            })
            .finally(() => {
              this.loading = false;
              this.fetchEmpresaAlteracoes();
            });
        },
      });
    },
    openEditModal(empresaAlteracao) {
      this.selectedEmpresaAlteracao = empresaAlteracao;
      this.empresaAlteracaoEditModalOpened = true;
    },
    relatorio() {
      window.open(
        `${process.env.VUE_APP_API_URL}/empresaAlteracao/relatorio/?token=${this.$store.getters.getToken}`,
        "_blank"
      );
    },
    onPageChange(page) {
      this.current_page = page;
    },
    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD HH:mm:ss").format(
        "DD/MM/YYYY HH:mm:ss"
      );

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
  },
};
</script>
